import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../AuthContext';

function Login() {
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        console.log(formData)
        try {
            const response = await axios.post('https://api.eazyworldehsengineering.com/api/auth/login', formData, {
                headers: { 'Content-Type': 'application/json' },
            });
            const data = response.data;
            console.log(data)
            login(data.user_id, data.access_token, data.first_name, data.last_name, data.email, data.username, data.role, data.permissions);
            console.log(localStorage);
            toastr.success("Logged in Successfully");
            navigate('/dashboard');

            // Reset form and show success message
            setFormData({ username: '', password: '' });
        } catch (error) {
            if (error.response) {
                setError(error.response.data.error);
                console.log(error.response.data.error)
                toastr.error(error.response.data.error);
            } else {
                setError('An error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-split">
            {/* Left: brand / marketing panel */}
            <div className="auth-visual">
                <div className="auth-visual-brand">
                    <span
                        style={{
                            width: '34px',
                            height: '34px',
                            borderRadius: '9px',
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="fas fa-shield-alt"></i>
                    </span>
                    Eazyworld EHS Engineering
                </div>

                <div className="auth-visual-content">
                    <h2>Excellence in Engineering, Safety &amp; Sustainability</h2>
                    <p>
                        One platform for candidate registration, training evaluation, certification
                        and compliance reporting - built for your EHS training operations.
                    </p>

                    <div className="auth-visual-features">
                        <div className="auth-visual-feature">
                            <span className="icon"><i className="fas fa-user-check"></i></span>
                            <div>
                                <strong>Registration &amp; Evaluation</strong>
                                <span>Track candidates from registration through pre/post evaluation.</span>
                            </div>
                        </div>
                        <div className="auth-visual-feature">
                            <span className="icon"><i className="fas fa-certificate"></i></span>
                            <div>
                                <strong>Certification &amp; Renewal</strong>
                                <span>Print certificates and keep renewals on schedule.</span>
                            </div>
                        </div>
                        <div className="auth-visual-feature">
                            <span className="icon"><i className="fas fa-chart-bar"></i></span>
                            <div>
                                <strong>Batch &amp; Compliance Reporting</strong>
                                <span>Monthly, batch-wise and consolidated reports at a glance.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right: sign-in form */}
            <div className="auth-form-side">
                <div className="auth-form-card">
                    <span className="auth-icon">
                        <i className="fas fa-shield-alt" style={{ color: '#fff', fontSize: '1.3rem' }}></i>
                    </span>
                    <h1 style={{ fontSize: '1.5rem', margin: '0 0 6px' }}>Welcome back</h1>
                    <p className="login-box-msg" style={{ textAlign: 'left', marginBottom: '26px' }}>
                        Sign in to your Eazyworld Engineering account
                    </p>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="input-group mb-3">
                            <input type="text" name="username" value={formData.username} onChange={handleChange} className="form-control" placeholder="Email" />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <span className="fas fa-envelope"></span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group mb-3">
                            <input type={showPassword ? "text" : "password"} name="password" value={formData.password} onChange={handleChange} className="form-control" placeholder="Password" />
                            <div className="input-group-append">
                                <div className="input-group-text">
                                    <a className="fas fa-eye" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}></a>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-8">
                                <div className="icheck-primary">
                                    <input type="checkbox" id="remember" />
                                    <label for="remember">
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="social-auth-links text-center mt-3 mb-1">
                            <button type="submit" className="btn btn-block btn-primary" disabled={loading}>
                                {loading ? 'Signing in...' : 'Sign In'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login